export const Roles = Object.freeze({
    ADMIN: 'ADMIN',
    PORTAL_PROJET: 'PORTAL_PROJET',
    PORTAL_MARKET: 'PORTAL_MARKET',
    PORTAL_DOCUMENT: 'PORTAL_DOCUMENT',


    PROJET_CREATE: 'PROJET_CREATE',
    PROJET_DELETE: 'PROJET_DELETE',
    PROJET_EDIT: 'PROJET_EDIT',
    PROJET_READ: 'PROJET_READ',
    COMMUNICATION: 'COMMUNICATION',

    MARKET_TYPE_CREATE: 'MARKET_TYPE_CREATE',
    MARKET_TYPE_EDIT: 'MARKET_TYPE_EDIT',
    MARKET_TYPE_DELETE: 'MARKET_TYPE_DELETE',
    MARKET_TYPE_READ: 'MARKET_TYPE_READ',

    // MARKET CATEGORY
    MARKET_CATEGORY_CREATE: 'MARKET_CATEGORY_CREATE',
    MARKET_CATEGORY_EDIT: 'MARKET_CATEGORY_EDIT',
    MARKET_CATEGORY_DELETE: 'MARKET_CATEGORY_DELETE',
    MARKET_CATEGORY_READ: 'MARKET_CATEGORY_READ',

    // DOCUMENT TYPE
    DOCUMENT_TYPE_CREATE: 'DOCUMENT_TYPE_CREATE',
    DOCUMENT_TYPE_EDIT: 'DOCUMENT_TYPE_EDIT',
    DOCUMENT_TYPE_DELETE: 'DOCUMENT_TYPE_DELETE',
    DOCUMENT_TYPE_READ: 'DOCUMENT_TYPE_READ',
});


export const Operations = Object.freeze({
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    CREATE: 'CREATE',
    DELETE: 'DELETE'
});
